import React from "react";
import styles from "./Header.scss";
import Logo from "../../assets/images/logo.png";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { Link, useHistory } from "react-router-dom";

const Header = () => {
  let history = useHistory();

  return (
    <>
      <header className={styles.header}>
        <Container>
          <Grid container spacing={12} alignItems="center">
            <Grid item xs={4}>
              <div className="logo">
                <Link to="/">
                  {" "}
                  <img src={Logo} alt="Logo" />
                </Link>
              </div>
            </Grid>
            <Grid item xs={8}>
              <div className="menu">
                <Link to="/" className="item">
                  <span>Home </span>
                </Link>
                <span
                  className="item"
                  onClick={() => {
                    if (history.location.pathname === "/") {
                      document.getElementById("quem-somos").scrollIntoView({
                        behavior: "smooth",
                      });
                    } else {
                      history.push("/");
                      setTimeout(() => {
                        document.getElementById("quem-somos").scrollIntoView({
                          behavior: "smooth",
                        });
                      }, 300);
                    }
                  }}
                >
                  <span>Quem somos</span>
                </span>
                <Link to="/produtos" className="item">
                  <span>Produtos e Serviços</span>
                </Link>
                <span
                  className="item"
                  onClick={() => {
                    if (history.location.pathname === "/") {
                      document.getElementById("form-home").scrollIntoView({
                        behavior: "smooth",
                      });
                    } else {
                      history.push("/");
                      setTimeout(() => {
                        document.getElementById("form-home").scrollIntoView({
                          behavior: "smooth",
                        });
                      }, 300);
                    }
                  }}
                >
                  <span> Contato e suporte</span>
                </span>
              </div>
            </Grid>
          </Grid>
        </Container>
      </header>
    </>
  );
};

export default Header;
